
import * as types from '../mutation-types'
import constans from '@/assets/js/constans'
import userService from "@/api/userService.js";
import { Message } from 'element-ui'

const state = {
  allPermissions: [],
  permissionInfo:{},
  selectedPermissions: [],
  isPermissionOpen: process.env.DOM_AUTHORITY  // dom控制权限开关
}

const getters = {
  getPermissionInfo:(state)=>{
    return state.permissionInfo;
  },
  permissionInfo: (state, getters, rootState) => menuId => {
    // let userInfo = rootState.login.userInfo
    // if(!state.isPermissionOpen || userInfo.isSuper == constans['SUPERADMIN']){
    //     return false;
    // }
    let menuPermission = state.selectedPermissions.find(item => item.menuId == menuId);
    let aAction = menuPermission ? menuPermission.split(',') : [];
    return state.allPermissions.reduce((total, item) => {
      item.parentId == menuId && (total[item.operKey] = aAction.indexOf(item.id) >= 0);
      return total;
    }, {});

  },
  currentMenuId(state, getters, rootState) {
    let selectMenu = rootState.getApp.selectMenu;
    return selectMenu && selectMenu.logicalId
  },
  currentPermissions(state, getters) {
    return state.allPermissions.filter(item => item.parentId == getters.currentMenuId);
  },
  isDisabled: (state, getters, rootState) => permissionId => {
    if(!permissionId){
      return
    }
    let userInfo = rootState.login.userInfo
    if (!state.isPermissionOpen || userInfo.isSuper == constans['SUPERADMIN']) {
      return false;
    }
    return !state.selectedPermissions.find(ite => {
      let aAction = ite.action.split(',');
      return aAction.indexOf(permissionId) >= 0
    })
  },
  isColumnDisabled: (state, getters, rootState) => (permissionId, columnId) => {
    let userInfo = rootState.login.userInfo
    if (!state.isPermissionOpen || userInfo.isSuper == constans['SUPERADMIN']) {
      return false;
    }
    return !state.selectedPermissions.find(ite => {
      // if(item.action.indexOf(':') >= 0){
      //     let aAction = item.action.split(':')[1].split(',');
      //     return item.columnId == columnId && aAction.indexOf(permissionId) >= 0
      // }
      if (ite.columnId&&ite.columnId!='null') {
        let aAction = ite.action.split(',');
        return ite.columnId == columnId && aAction.indexOf(permissionId) >= 0
      }
    })
  }
}

const actions = {
  findPermissions(context) {
    userService.getResponse('findPermissions', {}).then(response => {      
      context.commit('changeAllPermissions', response)      
      let data = {}
      response.forEach(element => {
        if(element.serviceType==1){
          data[element.operKey] = JSON.stringify(element.id)
        }        
      });
      context.commit('changePermissionInfo', data)
    }).catch(error => {
      // Message({
      //   message: error,
      //   type: 'error'
      // });
      this.$message.error('获取权限接口错误');
    });
  },

  getRoleIds(context, user) {
    let groupId = context.rootState.login.groupId
    let data = {}
    if(groupId&&groupId!='null'&&groupId!='undefined'){
      data.groupId = groupId
    }
    userService.getResponse('getRoles', data,false, {
      '{memberCode}':  user.memberCode
    }).then(res => {
      if(res.length) {
        context.dispatch('selectPermission', res.map(item => item.id))
      }
    }).catch(error => {
      
    });
  },

  selectPermission(context, roleIds) {
    let roleId = roleIds instanceof Array ? roleIds.join(',') : [];
    userService.getResponse('selectPermission', { roleIds: roleId }).then(response => {
      context.commit('changeSelectedPermissions', response)
      context.dispatch('findPermissions')
    }).catch(error => {
      // Message({
      //   message: error,
      //   type: 'error'
      // });
      //this.$message.error(error);
    });
  }

}

const mutations = {
  changePermissionInfo(state,result){
    state.permissionInfo = result
  },
  changeAllPermissions(state, result) {
    state.allPermissions = result;
  },
  changeSelectedPermissions(state, result) {
    state.selectedPermissions = result.rolePermissions[0].rolePermissions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/adminMan.js